<template>
  <div class="status-indicator">
    <div class="status-indicator__label">{{ label }}</div>
    <div class="status-indicator__dot" :style="`--status-indicator-color: var(--${status})`"></div>
  </div>
</template>

<script>
export default {
  props: {
    label: String,
    status: String,
  },
}
</script>

<style lang="scss">
.status-indicator {
  display: flex;
  align-items: center;
  gap: 0.25rem;

  font-size: 0.8rem;

  &__label {
    opacity: 0.7;
  }

  &__dot {
    --size: 8px;
    width: var(--size);
    aspect-ratio: 1 / 1;
    border-radius: var(--size);

    background-color: var(--status-indicator-color);
  }
}
</style>
